import { render, staticRenderFns } from "./orderDefault.vue?vue&type=template&id=72eaaa06&scoped=true&"
import script from "./orderDefault.vue?vue&type=script&lang=js&"
export * from "./orderDefault.vue?vue&type=script&lang=js&"
import style0 from "./orderDefault.vue?vue&type=style&index=0&id=72eaaa06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eaaa06",
  null
  
)

export default component.exports